import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks";
import { setUpdateActiveM024DetailsRequest } from "../slice";
import { ListItemM024 } from "./item/item";

interface Props {
    documentType: 'VALUTAZIONE' | 'RIESAME' | 'DECISIONE'
}

export function AllowProtM024List(props: Props) {
    const { documentType } = props
    const dispatch = useAppDispatch()
    const m024State = useAppSelector(state => state.m024)

    return (
        <div>
            {
                m024State.M024Attachments.map((ca, index) => (
                    <div className="pb-3" key={ca.id || ca.code}>
                        <ListItemM024
                            documentType={documentType}
                            id={ca.id || ''}
                            code={ca.code}
                            title={ca.attachmentName}
                            protocolIds={m024State.activeM024DetailsUpdateRequest.filter(det => det.entryProtocolAttachmentId === ca.id).map(d => d.id)}
                            numOfDetails={m024State.activeM024DetailsUpdateRequest.filter(det => det.entryProtocolAttachmentId === ca.id).length}
                        // protocolIds={m024State.activeM024DetailsUpdateRequest.filter(det => det.entryProtocolAttachmentId === ca.id).map(d => d.id)}
                        />
                    </div>
                ))
            }
        </div>
    )
}